import React, { useContext } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import { GeolocalizationContext } from '../../utils/contexts/geolocalization-context'
import ConditionalWrapper from '../../utils/helpers/conditionnal-wrapper'
import Markdown from '../parts/markdown'

/**
* Display a dynamic game rating logo, depending of the user's location
*/
const Ratings = (props) => {
  const { rating } = useContext(GeolocalizationContext)
  const [gameRating, setGameRating] = rating
  const locale = props.locale ? props.locale : 'en'

  if (!process.env.GATSBY_GEOLOCALIZATION || process.env.GATSBY_GEOLOCALIZATION === false || process.env.GATSBY_GEOLOCALIZATION === "false") {
    return (
      props.data && props.data.ratings && (
        <div className="container flex flex-col items-center pb-24 text-white">
          <img
            src={props.data.ratings.publicURL}
            className="h-auto w-auto max-w-[75px]"
          />
        </div>
      )
    )
  }

  const ConditionalLink = ({ condition, wrapper, children }) => condition ? wrapper(children) : children

  return (
    gameRating && (
      <ConditionalLink
        condition={gameRating.link}
        wrapper={children => <a href={gameRating.link} target={`_blank`} rel={`noopener noreferrer`}>{children}</a>}
      >
        {gameRating.text && gameRating.text !== null ? (
          <>
            {gameRating.textPosition && gameRating.textPosition === 'right' && (
              <div className={`ratings bg-white p-[1px] pr-6 text-black flex rounded-[8px] text-[13px] font-[Arial Narrow,sans-serif] items-center text-center rating-${gameRating.code}`}>
                {gameRating.logo && (
                  <img
                    src={gameRating.logo.publicURL ? gameRating.logo.publicURL : (gameRating.logo.localFile ? gameRating.logo.localFile.publicURL : null)}
                    className="h-32 w-auto mr-6"
                  />
                )}
                < Markdown children={gameRating.text} />
              </div>
            )}
            {gameRating.textPosition && gameRating.textPosition === 'top' && (
              <div className={`ratings flex flex-col text-[13px] items-center text-center rating-${gameRating.code}`}>
                <Markdown children={gameRating.text} />
                {gameRating.logo && (
                  <img
                    src={gameRating.logo.publicURL ? gameRating.logo.publicURL : (gameRating.logo.localFile ? gameRating.logo.localFile.publicURL : null)}
                    className="h-32 w-auto mt-8"
                  />
                )}
              </div>
            )}
          </>
        ) : (
          <>
            <div className={`ratings flex rating-${gameRating.code}`}>
              {gameRating.logo && (
                <ConditionalWrapper
                  condition={gameRating.link}
                  wrapper={children => <a href={gameRating.link} target="_blank" rel="noopener noreferrer" title={gameRating.code ? gameRating.code : ''}>{children}</a>}
                >
                  {gameRating.logo?.childImageSharp ? (
                    <GatsbyImage
                      image={gameRating.logo?.childImageSharp?.gatsbyImageData}
                      className="h-32 w-auto"
                      placeholder="blurred"
                      imgStyle={{ objectFit: `contain` }}
                      alt={`${gameRating.code?.toUpperCase()} Logo`}
                    />
                  ) : (
                    <img
                      src={gameRating.logo.publicURL ? gameRating.logo.publicURL : (gameRating.logo.localFile ? gameRating.logo.localFile.publicURL : null)}
                      className="h-32 w-auto"
                      alt={`${gameRating.code?.toUpperCase()} Logo`}
                    />
                  )}
                </ConditionalWrapper>
              )}
              {gameRating.logoDescriptor && gameRating.logoDescriptor !== null && (
                gameRating.logoDescriptor?.childImageSharp ? (
                  <GatsbyImage
                    image={gameRating.logoDescriptor?.childImageSharp?.gatsbyImageData}
                    className="h-32 w-auto ml-2"
                    placeholder="blurred"
                    imgStyle={{ objectFit: `contain` }}
                  />
                ) : (
                  <img
                    src={gameRating.logoDescriptor.publicURL ? gameRating.logoDescriptor.publicURL : (gameRating.logoDescriptor.localFile ? gameRating.logoDescriptor.localFile.publicURL : null)}
                    className="h-32 w-auto ml-2"
                  />
                )
              )}
            </div>
            {gameRating.provisional && (
              <span className={`rating-${gameRating.code}-provisional`}>
                {locale === 'en' ? (
                  'PROVISIONAL'
                ) : (
                  locale === 'fr' ? (
                    'PROVISOIRE'
                  ) : (
                    locale === 'es' ? (
                      'PROVISIONAL'
                    ) : (
                      locale === 'pt' || locale === 'pt-br' || locale === 'pt-BR' ? (
                        'PROVISÓRIO'
                      ) : (
                        'PROVISIONAL'
                      )
                    )
                  )
                )}
              </span>
            )}
          </>
        )}
      </ConditionalLink>
    )
  )
}

export default Ratings
